/* eslint import/prefer-default-export: 0 */

export const logout = {
  heading: 'Questionnaire for National Background Investigation Services',
  title: 'You have logged out',
  para: [''],
};
